export default __webpack_public_path__ + "static/media/paln3-information.13a53aca.svg";